import { apiRequest } from "../utils/useAPIRequest";
import constant from "../utils/constant";
import { invoiceStore } from "../stores";
import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";

const getAllInvoices = async () => {
  const query = "";
  const { status, errorMessage, data } = await apiRequest({
    url: `/invoices?${query}`,
    // url: `/invoices/business?${query}`,
    method: "get",
  });

  // console.log("data", data);

  if (status === constant.Success) {
    let invoices = [];
    data.invoices.forEach((invoice) => {
      invoices.push(...invoice.details);
    });
    const sortedInvoices = invoices.sort(
      (objA, objB) => Number(objA.number) - Number(objB.number)
    );
    const invoiceList = sortedInvoices.reverse();

    invoiceStore.setAllInvoices(invoiceList);

    return { status };
  }

  return { status, errorMessage };
};

const useGetAllInvoices = (invoiceTableQuery, filterQuery, searchQuery) => {
  const query = useMemo(() => {
    if (searchQuery && filterQuery) {
      return `${invoiceTableQuery}&${filterQuery}&search=${searchQuery}`;
    } else if (searchQuery) {
      return `${invoiceTableQuery}&search=${searchQuery}`;
    } else if (filterQuery) {
      return `${invoiceTableQuery}&${filterQuery}`;
    } else {
      return invoiceTableQuery;
    }
  }, [filterQuery, invoiceTableQuery, searchQuery]);

  return useQuery({
    queryKey: ["getAllInvoices", query],
    queryFn: () => {
      return apiRequest({
        url: `/invoices/new/admin?${query}`,
        method: "get",
      });
    },
    keepPreviousData: true,
  });
};

const getAllInvoicesAnalysis = async (query = "") => {
  const { status, errorMessage, data } = await apiRequest({
    url: `/invoices/new/analysis?${query}`,
    method: "get",
  });

  if (status === constant.Success) {
    invoiceStore.setAllInvoicesAnalysis(data);

    return { status };
  }

  return { status, errorMessage };
};

export default {
  getAllInvoices,
  getAllInvoicesAnalysis,
  useGetAllInvoices,
};
